import { useEffect } from 'react';
import { tableDefaultsFrom } from '../engine/settings/registry';
import { setTableDefaults } from '../utils/tableDefaults';

/**
 * usePublishTableDefaults - the shell publishes the table's display defaults (from the house rules) for the hooks
 * read too widely to take them as a prop (utils/tableDefaults). Once, in the shell.
 *
 * @param {Record<string, unknown> | undefined} houseRules
 */
export default function usePublishTableDefaults(houseRules) {
  useEffect(() => setTableDefaults(tableDefaultsFrom(houseRules)), [houseRules]);
  // Leaving the session leaves its table: its defaults must not follow the viewer to the Workshop or the lobby.
  useEffect(() => () => setTableDefaults({}), []);
}
